import { combineReducers } from 'redux'

import { CLEAR } from '../actions/clear'

import sessionReducer from './session'


const reducers = {
  user: sessionReducer,
}


export const createRootReducer = ( moreReducers = {}) =>{
  const allReducers = Object.assign({}, reducers, moreReducers )
  const appReducer = combineReducers( allReducers )

  return ( state, action ) => {
    if ( action.type === CLEAR ) {
      state = undefined
    }

    return appReducer( state, action )
  }
}
